import { CreateScreenReq, CreateScreenResp, ScreenerConfigEntity, ScreenerIntentEntity } from 'core/models';
import { inject, injectable } from 'inversify';
import { HttpClientService } from './http-client.service';

const API_BASE = '/api';

@injectable()
export class ScreenerService {
  @inject(HttpClientService)
  private httpClient: HttpClientService;

  private cache: ScreenerConfigEntity;

  public fetchScreenerConfig(): Promise<ScreenerConfigEntity> {
    return this.httpClient.get(API_BASE + '/v1/screener');
  }

  public cacheScreenerConfig(): Promise<void> {
    return this.fetchScreenerConfig().then((resp) => {
      this.cache = resp;
    });
  }

  public getScreenerConfig(): ScreenerConfigEntity {
    return this.cache;
  }

  public getIntentById(intentId: string): ScreenerIntentEntity {
    return this.cache.intents.find((intent) => intent.id === intentId) || ({} as ScreenerIntentEntity);
  }

  public createScreen(req: CreateScreenReq): Promise<CreateScreenResp> {
    return this.httpClient.post(API_BASE + '/v1/screener', req);
  }
}
